module.exports = __webpack_public_path__ + "img/bmsHome-hd.9bdd9077.jpg";